import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import useDeleteData from "../../repo/delete"; 

const DeleteButton = ({ data, userId, cargo, onDeleteSuccess }) => {
  const { deleteData, loading } = useDeleteData();
  const [showDialog, setShowDialog] = useState(false);

  const handleDelete = async () => {
    if (!userId) {
      
      return;
    }

    const endpoint = `api/${data}${userId}`;
    const jsonBody = { id: userId };

    const success = await deleteData(endpoint, jsonBody);

    if (success) {

      onDeleteSuccess(userId); 
    } else {

    }
  };

  const handleConfirmDelete = () => setShowDialog(true);
  const handleCancelDelete = () => setShowDialog(false);
  const handleDeleteConfirmed = () => {
    setShowDialog(false);
    handleDelete();
  };

  const footer = (
    <React.Fragment>
      <Button
        label="Sim"
        icon="pi pi-check"
        onClick={handleDeleteConfirmed}
        className="bg-emerald-500 text-white m-4 px-3 py-1 rounded-md shadow hover:bg-green-600 font-bold"
      />
      <Button
        label="Não"
        icon="pi pi-times"
        onClick={handleCancelDelete}
        className="bg-red-500 text-white  m-4  px-3 py-1 rounded-md shadow hover:bg-red-600 font-bold"
      />
    </React.Fragment>
  );

  return (
    <div>
      <Button
        onClick={handleConfirmDelete}
        disabled={loading}
        icon="pi pi-times"
        className="bg-red-500 text-white px-3 py-1 rounded-md shadow hover:bg-red-600 font-bold"
      >
        {loading ? "‎‎  Deletando..." : "‎‎  Deletar " + cargo}
      </Button>
      <Dialog
        visible={showDialog}
        style={{ width: "300px" }}
        footer={footer}
        onHide={() => setShowDialog(false)}
        header={"Confirma o delete do " + cargo + " ?"}
      >
        <p>Você está certo disso? ao fazer isso, o {cargo} ser&aacute; deletado.</p>
      </Dialog>
    </div>
  );
};

export default DeleteButton;
